import { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import HelperService from '../utility/HelperService';

interface propData {
    data: any
}

const InvoiceDetailAuthorizeWork = (props: propData) => {
    const [acceptedAmount, setAcceptedAmount] = useState<any>()
    const [rejectedAmount, setRejectedAmount] = useState<any>()

    useEffect(() => {
        var value = 0;
        var rejAmount = 0;
        for (var i in props?.data?.authWorks) {
            if (props?.data?.authWorks[i].acceptOrDeclined == true) {
                value += props?.data?.authWorks[i].quotedAmt
            } else {
                rejAmount += props?.data?.authWorks[i].quotedAmt
            }

        }
        setAcceptedAmount(value)
        setRejectedAmount(rejAmount)
    }, [])
    return (
        <>
            <Card className="card-style form-style" style={{ marginBottom: 50 }}>
                {
                    props?.data?.authWorks && props?.data?.authWorks.length > 0 && props?.data?.authWorks.map((res: any) => {
                        return (
                            <>
                                <div className='p-2'>
                                    <Row>
                                        <Col md={4}>
                                            <p className="mb-0 font-w-medium font-14">Description</p>
                                            <div className='recommendation-box'>{res.solnCodeDesc ? res.solnCodeDesc : '-'}</div>
                                        </Col>
                                        <Col md={4}>
                                            <p className="mb-0 font-w-medium font-14">COD Amount</p>
                                            <div className='recommendation-box'>{res.cod ? HelperService.getCurrencyFormatter(res.cod) : '-'}</div>
                                        </Col>
                                        <Col md={4}>
                                            <p className="mb-0 font-w-medium font-14">Quoted Amount</p>
                                            <div className='recommendation-box'>{res.quotedAmt ? HelperService.getCurrencyFormatter(res.quotedAmt) : '-'}</div>
                                        </Col>
                                        <Col md={12} className='mt-2'>
                                            <p className="mb-0 font-w-medium font-14">Comment</p>
                                            <div className='recommendation-box'>{res.myComments ? res.myComments : '-'}</div>
                                        </Col>
                                    </Row>
                                </div>
                                <hr />
                            </>
                        )
                    })
                }
            </Card>
            <Card className="card-style form-style mt-3">
                <Card.Body className="border-bottom border-light p-0 mt-4">
                    <Row>

                        <Col md={8} className="text-center payment-box-view p-4">
                            <div className="payment-title">Authorized Amount</div>
                            <div className="payment-amount">{acceptedAmount ? "$" + acceptedAmount.toFixed(2) : '$ 0.00'}</div>
                        </Col>
                        {
                            props?.data?.callInfo?.authWorkSignature ?
                                <Col md={4} className="text-center payment-box-view p-4">
                                    <div className="">
                                        {props?.data?.callInfo?.authWorkSignature && <img src={`data:image/png;base64,${props?.data?.callInfo?.authWorkSignature}`} style={{ height: 100, width: 200 }} />}
                                        <div style={{ marginRight: 50, }}>
                                            {props?.data?.callInfo?.authWorkSignedBy && <div>{props?.data?.callInfo?.authWorkSignedBy}</div>}
                                            {props?.data?.callInfo?.authWorkSignedOn && <div>{HelperService.getFormatedDateAndTime(props?.data?.callInfo?.authWorkSignedOn)}</div>}
                                        </div>
                                    </div>
                                </Col> : null
                        }
                    </Row>
                </Card.Body>
            </Card>
        </>
    )
}

export default InvoiceDetailAuthorizeWork;